const questions = [
  {
    id: 1,
    title: 'Do I have to allow the use of cookies?',
    info:
      'Lorem ipsum dolor, sit amet consectetur adipisicing elit. Qui placeat natus illo ipsum architecto expedita aperiam nam. Sit vel consequuntur magnam tenetur dolorem dolorum cupiditate aliquid totam quibusdam eius',
  },
  {
    id: 2,
    title: 'How do I change my My Page password?',
    info:
      'Lorem ipsum dolor, sit amet consectetur adipisicing elit. Qui placeat natus illo ipsum architecto expedita aperiam nam. Sit vel consequuntur magnam tenetur dolorem dolorum cupiditate aliquid totam quibusdam eius',
  },
  {
    id: 3,
    title: 'What is BankID?',
    info:
      'Lorem ipsum dolor, sit amet consectetur adipisicing elit. Qui placeat natus illo ipsum architecto expedita aperiam nam. Sit vel consequuntur magnam tenetur dolorem dolorum cupiditate aliquid totam quibusdam eius',
  },
  {
    id: 4,
    title: 'Whose birth number can I use?',
    info:
      'Lorem ipsum dolor, sit amet consectetur adipisicing elit. Qui placeat natus illo ipsum architecto expedita aperiam nam. Sit vel consequuntur magnam tenetur dolorem dolorum cupiditate aliquid totam quibusdam eius',
  },
  {
    id: 5,
    title: 'When do I recieve a password ordered by letter?',
    info:
      'Lorem ipsum dolor, sit amet consectetur adipisicing elit. Qui placeat natus illo ipsum architecto expedita aperiam nam. Sit vel consequuntur magnam tenetur dolorem dolorum cupiditate aliquid totam quibusdam eius ',
  },
]
export default questions
